import { useCallback, useEffect, useMemo, useState } from 'react'
import { matchPath, useLocation } from 'react-router-dom'

import { ZAI_SIDE_CHAT_TOGGLE_EVENT } from 'modules/zai/common/zai.consts'

import { ZAI_SIDE_CHAT_OPEN_EVENT, ZAI_PAGES_EXCEPTION } from './zai-side-chat.consts'
import type { TZaiSideChatModelReturn } from './zai-side-chat.types'

export const useZaiSideChatModel = (): TZaiSideChatModelReturn => {
  const { pathname } = useLocation()
  const [isOpen, setIsOpen] = useState(false)

  const shouldSideChatHidden = useMemo(() => ZAI_PAGES_EXCEPTION.some(page => matchPath(pathname, page)), [pathname])

  const onOpenChange = useCallback(
    (open: boolean) => {
      if (shouldSideChatHidden && open) return
      setIsOpen(open)
    },
    [shouldSideChatHidden]
  )

  useEffect(() => {
    if (shouldSideChatHidden) setIsOpen(false)
  }, [shouldSideChatHidden])

  useEffect(() => {
    const handleOpenEvent = () => onOpenChange(true)
    const handleToggleEvent = () => setIsOpen(prev => (shouldSideChatHidden ? false : !prev))

    window.addEventListener(ZAI_SIDE_CHAT_OPEN_EVENT, handleOpenEvent)
    window.addEventListener(ZAI_SIDE_CHAT_TOGGLE_EVENT, handleToggleEvent)

    return () => {
      window.removeEventListener(ZAI_SIDE_CHAT_OPEN_EVENT, handleOpenEvent)
      window.removeEventListener(ZAI_SIDE_CHAT_TOGGLE_EVENT, handleToggleEvent)
    }
  }, [onOpenChange, shouldSideChatHidden])

  return { isOpen, onOpenChange }
}
